import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "370px",
    maxWidth: "450px",
    "& .MuiFormHelperText-root": {
      color: "#ffcc00",
    },
  },
  card: {
    color: theme.palette.text.tertiary,
    borderRadius: "10px",
  },
  cardContent: {
    backgroundColor: theme.palette.primary.main,
    padding: "30px",
    position: "relative",
    minHeight: "300px",
  },

  cardContentDiv1: {
    justifyContent: "space-around",
    marginTop: "5%",
  },
  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    padding: "3px",
    borderRadius: "10px",
  },

  cardContentDiv4: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "3px",
    height: "10vh",
    width: "100%",
  },

  cardContentInput2: {
    width: "100% ",
    padding: "0px 4px",
    maxHeight: "100%",
    overflow: "hidden",
  },

  cardContentInput1: {
    padding: "0.2px 6px",
  },

  done: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    marginTop: "10px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      background: theme.palette.secondary.light,
      color: theme.palette.text.primary,
    },
  },

  cardAction: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "center",
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  addNewStatusButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
  },
  defaultButton: {
    color: theme.palette.text.tertiary,
    minWidth: 0,
    padding: "0px",
  },
  selectedButton: {
    color: theme.palette.text.primary,
    minWidth: 0,
    padding: "0px",
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "0px",
  },
}));

export default useStyles;
